import { OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { MessageService, Message, MessageType } from '../../services/message.service';
import { LanguageService } from '../../services/language.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';

export class DatapickerBaseControl implements OnInit, OnDestroy {

  @Input()
  placeholder: string;

  @Input()
  cssClass: string;

  @Input()
  minDate: Date;

  @Input()
  maxDate: Date;

  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();

  @Output()
  valueChange: EventEmitter<Date[]> = new EventEmitter<Date[]>();

  private messageSubscription: Subscription;

  constructor(
    protected languageService: LanguageService,
    protected messageService: MessageService,
  ) {
    this.dpConfig.containerClass = 'theme-dark-blue';
    this.updateLocale();
  };

  ngOnInit() {
    this.messageSubscription = this.messageService.getSubscription()
      .filter((x: Message) => [MessageType.LanguageChanged].indexOf(x.messageType) > -1)
      .subscribe(message => this.onMessage(message));
  }

  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
  }

  private onMessage(message: Message) {
    if (message.messageType == MessageType.LanguageChanged) {
      this.updateLocale();
    }
  }

  updateLocale() {
    const locale = this.languageService.getLanguage();
    if (locale === 'de-DE' || locale === 'cs-CZ' || locale === 'uk-UA') {
      this.dpConfig.dateInputFormat = 'DD.MM.YYYY';
      this.dpConfig.rangeInputFormat = 'DD.MM.YYYY';
    } else {
      this.dpConfig.dateInputFormat = 'L';
      this.dpConfig.rangeInputFormat = 'L';
    }
  }

  onBsValueChange(value: Date[]): void {
    this.valueChange.emit(value);
  }
}
